/**
 * TagInStory — Figma-aligned character count legend tag for the story reader.
 *
 * Props:
 *   state — 'known' | 'practicing' | 'to_learn'
 *   count — number to display in the counter badge
 *   style — optional override styles
 */
import { useTranslation } from 'react-i18next';
import s from './TagInStory.module.css';

const STATE_CONFIG = {
  known:      { color: '#766855', labelKey: 'common.known' },
  practicing: { color: '#2ab8a8', labelKey: 'common.practicing' },
  to_learn:   { color: '#ff6821', labelKey: 'common.new' },
};

export default function TagInStory({ state = 'to_learn', count, style }) {
  const { t } = useTranslation();
  const config = STATE_CONFIG[state] || STATE_CONFIG.to_learn;

  return (
    <span
      className={s.tag}
      style={{ '--tag-color': config.color, ...style }}
    >
      {count != null && (
        <span className={s.badge}>{count}</span>
      )}
      <span className={s.label}>{t(config.labelKey)}</span>
    </span>
  );
}
